var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3203 12.5781H11.5703V15.0781H10.3203V12.5781ZM13.4453 11.3281H14.6953V15.0781H13.4453V11.3281ZM7.19531 8.82812H8.44531V15.0781H7.19531V8.82812Z",
    fill: "#9C4900",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5703 3.20312H14.6953V2.57812C14.6953 2.2466 14.5636 1.92866 14.3292 1.69424C14.0948 1.45982 13.7768 1.32813 13.4453 1.32812H8.44531C8.11379 1.32813 7.79585 1.45982 7.56143 1.69424C7.32701 1.92866 7.19531 2.2466 7.19531 2.57812V3.20312H5.32031C4.98879 3.20312 4.67085 3.33482 4.43643 3.56924C4.20201 3.80366 4.07031 4.1216 4.07031 4.45312V17.5781C4.07031 17.9096 4.20201 18.2276 4.43643 18.462C4.67085 18.6964 4.98879 18.8281 5.32031 18.8281H16.5703C16.9018 18.8281 17.2198 18.6964 17.4542 18.462C17.6886 18.2276 17.8203 17.9096 17.8203 17.5781V4.45312C17.8203 4.1216 17.6886 3.80366 17.4542 3.56924C17.2198 3.33482 16.9018 3.20312 16.5703 3.20312ZM8.44531 2.57812H13.4453V5.07812H8.44531V2.57812ZM16.5703 17.5781H5.32031V4.45312H7.19531V6.32812H14.6953V4.45312H16.5703V17.5781Z",
    fill: "#9C4900",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.ad3aa277dd45715036397aba51c2f5fd.svg";
export { ForwardRef as ReactComponent };